import { ProductImageRendition } from "@omni/types/api/product/shared/enums/productImageRendition.enum";
import { MainImage } from "@omni/types/api/shared/bff/mainImage.model";
import { Media } from "@omni/types/api/shared/bff/media.model";

type ArticleConfigurationValues = {
    imageURL?: string | null;
};

export const getMedias = (
    isWarrentyDeposit: boolean,
    title?: string,
    mainImages?: Array<MainImage> | null,
    articleConfiguration?: ArticleConfigurationValues | null
) => {
    if (isWarrentyDeposit) {
        return null;
    }

    if (articleConfiguration) {
        return [
            {
                url: articleConfiguration.imageURL || "",
                format: ProductImageRendition.SM,
                altText: title
            } as Media
        ];
    }

    return mainImages?.[0]?.medias || [];
};
